import React, { useState } from 'react';
import { is8DataApp } from '../../../utils';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme: any) => ({
  card: {
    backgroundColor: theme.palette.brand.greyMid,
    borderRadius: theme.spacing(1),
    border: `1px solid ${theme.palette.brand.greyWhite}`,
    marginBottom: theme.spacing(1),
  },
  cardHeader: {
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    borderBottom: `1px solid ${theme.palette.brand.greyWhite}`,
    cursor: 'pointer',
    display: 'flex',
  },
  cardContent: {
    overflowY: 'auto',
  },
  cardTop: {
    background: theme.palette.gradient.accountHeader,
    height: theme.spacing(1),
    borderTopRightRadius: theme.spacing(1),
    borderTopLeftRadius: theme.spacing(1),
  },
  arrowWrapper: {
    marginLeft: 'auto',
  },
  arrow: {
    transition: 'transform 0.2s linear',
    marginTop: '100%',
    transform: 'rotate(180deg)',
  },
  closedArrow: {
    transform: 'rotate(0deg)',
  },
}));

export default function Card(props) {
  const classes = useStyles();
  const { title, children, shouldExpand } = props;
  const [isExpanded, setIsExpanded] = useState(shouldExpand === true);

  const arrowExtraClass = isExpanded ? classes.closedArrow : '';
  const is8Data = is8DataApp();

  return (
    <div className={classes.card}>
      <div className={classes.cardTop} />
      <div
        className={classes.cardHeader}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Typography variant="h6" align="left" style={{ fontWeight: 600 }}>
          {title}
        </Typography>
        <div className={classes.arrowWrapper}>
          <img
            src={
              is8Data
                ? 'icons/8data/arrowUpFilled.svg'
                : 'icons/arrowUpFilled.svg'
            }
            alt=""
            className={`${classes.arrow} ${arrowExtraClass}`}
          />
        </div>
      </div>
      {isExpanded && <div className={classes.cardContent}>{children}</div>}
    </div>
  );
}
